// extracted by mini-css-extract-plugin
export default {"buttons":"n0AvZB","login":"lgxzCy","resetLink":"L_VHLQ","title":"bRojrR"};